module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIiB2aWV3Qm94PSIwIDAgNzIgNDgiPjxwYXRoIGQ9Ik0wIDQ4VjBoNzJ6IiBmaWxsPSIjMWViNTNhIi8+PHBhdGggZD0iTTAgNDhoNzJWMHoiIGZpbGw9IiMwMGEzZGQiLz48cGF0aCBkPSJNMCA0OEw3MiAwIiBzdHJva2U9IiNmY2QxMTYiIHN0cm9rZS13aWR0aD0iMTkiLz48cGF0aCBkPSJNMCA0OEw3MiAwIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMTMiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/tza.svg
// module id = DjYR
// module chunks = 0